'use client';

import { useEffect } from 'react';

import { setHeaderScrolled } from '@/store/header.store';

const SCROLL_THRESHOLD = 64;

export function useSearchHeaderScroll() {
  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (ticking) {
        return;
      }

      ticking = true;
      window.requestAnimationFrame(() => {
        setHeaderScrolled(window.scrollY > SCROLL_THRESHOLD);
        ticking = false;
      });
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      setHeaderScrolled(false);
    };
  }, []);
}
